import React from 'react';


const icons = {
    download: {
        viewBox: '0 0 24 24',
        color: '#2B3F63',
        path: 'M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM12 17L8 13H11V9.02L13 9V13H16L12 17Z'
    },
    approve: {
        viewBox: '0 0 24 24',
        color: '#1CAA53',
        path: 'M23 12L20.56 9.21998L20.9 5.53998L17.29 4.71998L15.4 1.53998L12 2.99998L8.6 1.53998L6.71 4.71998L3.1 5.52998L3.44 9.20998L1 12L3.44 14.78L3.1 18.47L6.71 19.29L8.6 22.47L12 21L15.4 22.46L17.29 19.28L20.9 18.46L20.56 14.78L23 12ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.57998L18 8.99998L10 17Z'
    },
    decline: {
        viewBox: '0 0 24 24',
        color: '#BE1C1C',
        path: 'M19.1 4.89998C15.2 0.999976 8.79998 0.999976 4.89998 4.89998C0.999976 8.79998 0.999976 15.2 4.89998 19.1C8.79998 23 15.1 23 19 19.1C22.9 15.2 23 8.79998 19.1 4.89998ZM14.8 16.2L12 13.4L9.19998 16.2L7.79998 14.8L10.6 12L7.79998 9.19998L9.19998 7.79998L12 10.6L14.8 7.79998L16.2 9.19998L13.4 12L16.2 14.8L14.8 16.2Z'
    },
    reason: {
        viewBox: '0 0 20 20',
        color: '#2B3F63',
        path: 'M13.07 9.25L12.17 10.17C11.45 10.89 11 11.5 11 13H9V12.5C9 11.39 9.45 10.39 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.84 13.66 8.65 13.07 9.25ZM11 17H9V15H11M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0Z'
    },
    rollback: {
        viewBox: '0 0 24 24',
        color: '#BE1C1C',
        path: 'M20.2844 7.46564L15.0344 2.21564C14.8915 2.07635 14.6995 1.99889 14.5 2.00001H5.5C5.10218 2.00001 4.72064 2.15805 4.43934 2.43935C4.15804 2.72066 4 3.10219 4 3.50001V20C4 20.3978 4.15804 20.7794 4.43934 21.0607C4.72064 21.342 5.10218 21.5 5.5 21.5H19C19.3978 21.5 19.7794 21.342 20.0607 21.0607C20.342 20.7794 20.5 20.3978 20.5 20V8.00001C20.5011 7.80048 20.4237 7.60851 20.2844 7.46564ZM15.0344 15.7156C15.1752 15.8578 15.2542 16.0499 15.2542 16.25C15.2542 16.4501 15.1752 16.6422 15.0344 16.7844C14.891 16.923 14.6994 17.0005 14.5 17.0005C14.3006 17.0005 14.109 16.923 13.9656 16.7844L12.25 15.0594L10.5344 16.7844C10.391 16.923 10.1994 17.0005 10 17.0005C9.80059 17.0005 9.60898 16.923 9.46563 16.7844C9.32479 16.6422 9.24578 16.4501 9.24578 16.25C9.24578 16.0499 9.32479 15.8578 9.46563 15.7156L11.1906 14L9.46563 12.2844C9.34603 12.1387 9.28491 11.9537 9.29416 11.7654C9.3034 11.5771 9.38236 11.399 9.51566 11.2657C9.64896 11.1324 9.82708 11.0534 10.0154 11.0442C10.2037 11.0349 10.3887 11.096 10.5344 11.2156L12.25 12.9406L13.9656 11.2156C14.1113 11.096 14.2963 11.0349 14.4846 11.0442C14.6729 11.0534 14.851 11.1324 14.9843 11.2657C15.1176 11.399 15.1966 11.5771 15.2058 11.7654C15.2151 11.9537 15.154 12.1387 15.0344 12.2844L13.3094 14L15.0344 15.7156ZM14.5 8.00001V3.87501L18.625 8.00001H14.5Z'
    }
};


export default function ContractActionIcon({type}) {
    const icon = icons[type];

    if (!icon) {
        return null;
    }

    return (
        <svg
            className="contract-action-icon"
            viewBox={icon.viewBox}
            aria-hidden="true"
            focusable="false"
        >
            <path
                d={icon.path}
                fill={icon.color}
            />
        </svg>
    );
}
